import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from "@angular/core";

@Component({
  selector: "launch-countdown-digit",
  templateUrl: "./launch-countdown-digit.component.html",
  styleUrls: ["./launch-countdown-digit.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LaunchCountdownDigitComponent {
  @Input() public numDigitValues: number = 10;
  @Input() public top: number = 0;

  digitValues: number[];

  ngOnInit() {
    this.digitValues = Array.from({ length: this.numDigitValues }, (_, i) => i);
  }
}
